/* unplugin-vue-components disabled */import script from "./stationNews.vue?vue&type=script&setup=true&lang=js"
export * from "./stationNews.vue?vue&type=script&setup=true&lang=js"

import "./stationNews.vue?vue&type=style&index=0&id=7dc9d025&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc9d025"]])

export default __exports__